import { type } from '@testing-library/user-event/dist/cjs/utility/type.js';
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Col, FormGroup, Row } from 'reactstrap'
import useAddProductPrice from '../Hooks/useAddProductPrice';
import useUpdateProductPricing from '../Hooks/useUpdateProductPricing';
import { useQueryClient } from '@tanstack/react-query';
import useInitialData from 'context/useInitialData';

const AddEditPriceForm = ({isEditMode,priceData,onClose}) => {
    const queryClient = useQueryClient();

    // products data
    // const initData = queryClient.getQueryData(['initialData'])
    const{data:initData} = useInitialData();
    const products = initData?.products || []

    // hook for adding data
    const{isAdding,isAdded,addPrice}=useAddProductPrice();
    // hook for updating data
    const{isUpdating,isUpdated,updatePrice}=useUpdateProductPricing();

    const{register,handleSubmit,formState:{errors,isSubmitting},reset} = useForm({
        defaultValues:{
            product:"",
            price:"",
            fromDate:""
        },
        criteriaMode:"all",
        mode:"onChange"
    })

    // when editing,populate from existing data
    useEffect(()=>{
        if(isEditMode && priceData){
            const formValues = {
                product: priceData.product,
                price: priceData.price,
                fromDate: priceData.from_date ? priceData.from_date.split("T")[0] : ""
            }

            reset(formValues);
        }else{
            reset();
        }
    },[isEditMode,priceData,reset])

    const onSubmit=async(data)=>{
        const payload = {
            product: data.product,
            org: priceData.org,
            price: data.price,
            from_date: data.fromDate,

            ...(isEditMode && {id:priceData.id})
        }
        console.log("org",priceData.org)
        if(isEditMode){
            updatePrice(payload,{
                onSuccess:(updatedPrice)=>{
                    onClose();
                    queryClient.setQueryData(
                        ['priceList'],
                        (old)=> ({
                            ...old,
                            results: old.results.map(
                                price => price.id === updatedPrice.id ? updatedPrice : price
                            )

                        })
                    )
                }
            })
        }else{
            addPrice(payload,{
                onSuccess:(newPrice)=>{
                    onClose();
                    queryClient.setQueryData(
                        ['priceList'],
                        (old)=> ({
                            ...old,
                            results: [...old?.results || [],newPrice]
                        })
                    )
                }
            })
        }
    }

    return (
    <form onSubmit={handleSubmit(onSubmit)} className='p-4'>
      <Row>
        <Col>
            <FormGroup>
                <label htmlFor='product' className='form-label'>Product</label>
                <select
                    className='form-select border-primary-subtle'
                    id='product'
                    name='product'
                    {...register('product',{required:"Product is Required"})}
                >
                    <option value="" disabled>Select Product</option>
                    {products.map((product,index)=>(
                        <option key={index} value={product.id}>{product.product_name}</option>
                    ))}
                </select>
            </FormGroup>
            {errors.product && <span className='text-danger'>{errors.product.message}</span>}
        </Col>

        <Col>
            <FormGroup>
                <label htmlFor='price' className='form-label'>Price</label>
                <input
                    type='number'
                    className='form-control border-primary-subtle'
                    id='price'
                    name='price'
                    placeholder='Price'
                    min={0}
                    {...register('price',{required:"Price is Required",min:{
                        value:0,message:"Minimum value cannot be less than zero"
                    }})}
                />
                {errors.price && <span className='text-danger'>{errors.price.message}</span>}
            </FormGroup>
        </Col>

        <Col>
            <FormGroup>
                <label htmlFor='fromDate' className='form-label'>From Date</label>
                <input
                    type='date'
                    className='form-control border-primary-subtle'
                    id='fromDate'
                    name='fromDate'
                    min={new Date().toISOString().split("T")[0]}
                    {...register('fromDate',{required:"Date is Required",
                        validate: (value) => {
                            const today = new Date().toISOString().split("T")[0];
                            return value >= today || "Previous dates are not allowed"
                        }
                    })}
                />
                {errors.fromDate && <span className='text-danger'>{errors.fromDate.message}</span>}
            </FormGroup>
        </Col>
      </Row>
      <Row className='justify-content-between align-items-center'>
            <Button
                type='submit'
                style={{
                    backgroundColor: "#00ADF0",
                    color: "white",
                    fontWeight: "600",
                    border: "none"
                }}
                disabled={isSubmitting || isAdding || isUpdating}
            >
                Add
            </Button>
      </Row>
    </form>
  )
}

export default AddEditPriceForm
